import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "expandedListFilter",
})

export class ExpandedListFilterPipe implements PipeTransform {
  public transform( value: any[], searchString: string ) {
   if (!searchString) {
     return value;
   }

   const searchStringFormatted = searchString.toLowerCase();

   return value.filter( (it) => {
     const name = it.name ? it.name.toLowerCase().includes(searchStringFormatted) : false;
     const createdBy = it.createdBy ? it.createdBy.toLowerCase().includes(searchStringFormatted) : false;
     const createdById = it.createdById ? it.createdById.toLowerCase().includes(searchStringFormatted) : false;
     const lastChangedBy = it.lastChangedBy ? it.lastChangedBy.toLowerCase().includes(searchStringFormatted) : false;
     const lastChangedById = it.lastChangedById ? it.lastChangedById.toLowerCase().includes(searchStringFormatted) : false;
     const lastPublishedBy = it.lastPublishedBy ? it.lastPublishedBy.toLowerCase().includes(searchStringFormatted) : false;
     const lastPublishedById = it.lastPublishedById ? it.lastPublishedById.toLowerCase().includes(searchStringFormatted) : false;
     return (name + lastChangedBy + createdBy + createdById + lastChangedById + lastPublishedById + lastPublishedBy);
   });
  }
}
